module.exports = __webpack_public_path__ + "593a3d53/img/chevron-down-icon.5542f65c.svg";